"use client";

import React from "react";

const SiteTerms = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-white dark:bg-boxdark text-black dark:text-white px-6 py-12">
      <h1 className="text-3xl font-bold mb-6">Site Terms</h1>
      <div className="max-w-3xl text-justify">
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">Effective as of 4/1/2025</p>
        
        <p className="mb-4">
          Welcome to LinqOps! These Terms of Use ("Terms") govern your access to and use of our website, web-based software platform, and related tools (collectively, the "Site") provided by LinqOps LLC. ("LinqOps," "we," "us," or "our"), a company based in the State of New Jersey. By accessing or using the Site, you agree to be bound by these Terms. If you do not agree to these Terms, do not use the Site.
        </p>
        <p className="mb-6">
          If you enter into a separate agreement with LinqOps for the use of our platform or services, that agreement will control in the event of a conflict.
        </p>

        <h2 className="text-xl font-semibold mb-2">Overview of Our Services</h2>
        <p className="mb-6">
          LinqOps is a software-as-a-service (SaaS) platform designed to help delivery operations teams optimize their logistics workflows. Our services include a web-based platform and an optional Chrome extension that helps users extract data from logistics websites to generate operational insights.
        </p>
        
        <h2 className="text-xl font-semibold mb-2">Privacy</h2>
        <p className="mb-6">
          Your use of the Site is also governed by our{" "}
          <a href="/privacy-policy" className="text-primary hover:underline">
            Privacy Policy
          </a>{" "}
          and{" "}
          <a href="/sms-privacy-policy" className="text-primary hover:underline">
            SMS Privacy Policy
          </a>
          , which explain how we collect, use, and safeguard your personal and operational data, including information related to SMS communications. Please review them carefully.
        </p>
                
        <h2 className="text-xl font-semibold mb-2">Eligibility and Account Responsibility</h2>
        <p className="mb-6">
          To use our platform, you must be at least 18 years old and capable of forming a binding contract. You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account. Notify us immediately if you suspect unauthorized use.
        </p>
                
        <h2 className="text-xl font-semibold mb-2">Limited License and Acceptable Use</h2>
        <p className="mb-4">
          LinqOps grants you a limited, non-exclusive, non-transferable, revocable license to access and use the Site solely for your internal business operations.
        </p>
        <p className="mb-2">You may not:</p>
        <ul className="list-disc pl-8 mb-4">
          <li className="mb-1">Copy, modify, or reverse engineer any part of the Site</li>
          <li className="mb-1">Use the Site to transmit unlawful, harmful, or malicious content</li>
          <li className="mb-1">Interfere with or attempt to gain unauthorized access to the Site or its infrastructure</li>
        </ul>
        <p className="mb-6">
          We reserve the right to suspend or terminate your access if you violate these Terms.
        </p>
                
        <h2 className="text-xl font-semibold mb-2">Chrome Extension Usage</h2>
        <p className="mb-4">
          If you install the LinqOps Chrome extension, you authorize it to access specific logistics-related websites to collect data necessary for generating operational insights. The extension collects only the data required to perform its functions and does not sell or share data with third parties.
        </p>
        <p className="mb-6">
          Use of the extension is optional. Users may instead manually input logistics data into the LinqOps platform.
        </p>
                
        <h2 className="text-xl font-semibold mb-2">Intellectual Property</h2>
        <p className="mb-6">
          All content, software, and technology on the Site, including but not limited to text, graphics, logos, and code, are the property of LinqOps or its licensors and are protected by U.S. and international intellectual property laws. You may not use our trademarks, logos, or branding without our express written permission.
        </p>
                
        <h2 className="text-xl font-semibold mb-2">Feedback</h2>
        <p className="mb-6">
          If you submit feedback or suggestions regarding LinqOps, you grant us a non-exclusive, royalty-free, worldwide license to use, modify, and incorporate that feedback without restriction.
        </p>
                
        <h2 className="text-xl font-semibold mb-2">Disclaimers and Limitation of Liability</h2>
        <p className="mb-4">
          The Site and all content, features, and services are provided "as is" and "as available," without warranties of any kind. LinqOps disclaims all warranties, express or implied, including merchantability, fitness for a particular purpose, and non-infringement.
        </p>
        <p className="mb-6">
          To the fullest extent permitted by law, LinqOps is not liable for any indirect, incidental, or consequential damages arising from your use of or inability to use the Site or services, even if we have been advised of the possibility of such damages.
        </p>
                
        <h2 className="text-xl font-semibold mb-2">Governing Law and Jurisdiction</h2>
        <p className="mb-6">
          These Terms are governed by the laws of the State of New Jersey, without regard to its conflict of law principles. You agree to the exclusive jurisdiction and venue of the federal and state courts located in New Jersey for any disputes arising from these Terms or your use of the Site.
        </p>
                
        <h2 className="text-xl font-semibold mb-2">Changes to These Terms</h2>
        <p className="mb-6">
          We may update these Terms from time to time. When we do, we will revise the "Effective Date" above. Continued use of the Site after changes become effective constitutes your acceptance of the revised Terms.
        </p>
                
        <h2 className="text-xl font-semibold mb-2">Contact Us</h2>
        <p className="mb-6">
          If you have any questions about these Terms or need support, please contact us at:<br />
          Email: <a href="mailto:support@linqops.com" className="text-primary hover:underline">support@linqops.com</a>
        </p>
      </div>
    </div>
  );
};

export default SiteTerms;